import { ERR_NOT_IMPLEMENTED } from "../../utils/error";
export class AbstractCommand {
    constructor(pApp) {
        this.mApp = pApp;
    }
    isAvailable() {
        return (true);
    }
    isUndoable() {
        return (false);
    }
    isSignificant() {
        return (false);
    }
    undo() {
        return (Promise.reject(new Error(ERR_NOT_IMPLEMENTED)));
    }
    redo() {
        return (Promise.reject(new Error(ERR_NOT_IMPLEMENTED)));
    }
    dispose() {
    }
}
